/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The UsersUserIdBody model module.
 * @module model/UsersUserIdBody
 * @version 1.0.0
 */
export class UsersUserIdBody {
  /**
   * Constructs a new <code>UsersUserIdBody</code>.
   * @alias module:model/UsersUserIdBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>UsersUserIdBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/UsersUserIdBody} obj Optional instance to populate.
   * @return {module:model/UsersUserIdBody} The populated <code>UsersUserIdBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new UsersUserIdBody();
      if (data.hasOwnProperty('username'))
        obj.username = ApiClient.convertToType(data['username'], 'String');
      if (data.hasOwnProperty('firstName'))
        obj.firstName = ApiClient.convertToType(data['firstName'], 'String');
      if (data.hasOwnProperty('lastName'))
        obj.lastName = ApiClient.convertToType(data['lastName'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} username
 */
UsersUserIdBody.prototype.username = undefined;

/**
 * @member {String} firstName
 */
UsersUserIdBody.prototype.firstName = undefined;

/**
 * @member {String} lastName
 */
UsersUserIdBody.prototype.lastName = undefined;

